import _ from 'lodash'
import SecureLS from 'secure-ls'
import config from './_config'
import { storageAvailable } from '../_utils'

export let LS = new SecureLS({ encodingType: 'aes', isCompression: false })

// Local Storage Versioning
const saveVersionToStorage = (version) => {
  if (!storageAvailable) return
  LS.set('dashboardAppVersion', version)
}
const getVersionFromStorage = () => {
  if (!storageAvailable) return
  const version = LS.get('dashboardAppVersion')
  return version
}
export const handleAppVersioning = () => {
  if (!storageAvailable) return

  const storedAppVersion = getVersionFromStorage()
  const currentVersion = config.appVersion

  if (storedAppVersion != currentVersion) {
    LS.removeAll()
    saveVersionToStorage(currentVersion)

    console.info('Updating app version to: ' + currentVersion)
    window.location.reload()
  }
}

// PRODUCTS
export const saveProductsToStorage = (store) => {
  if (!storageAvailable) return
  let products = JSON.stringify(store.getState().products.list)
  store.subscribe(() => {
    let oldProducts = products
    products = JSON.stringify(store.getState().products.list)
    if (products !== oldProducts) {
      // localStorage.setItem('products', JSON.stringify(currentValue));
      // console.log('PRODUCTS updated');
      LS.set('products', JSON.parse(products))
    }
  })
}
export const getProductsFromStorage = (store) => {
  if (!storageAvailable) return
  // const products = localStorage.getItem('products');
  const products = LS.get('products')
  if (!products) return
  store.dispatch({
    type: 'SET_PRODUCTS_LIST',
    list: _.keyBy(products, 'id'),
  })
}

// CATEGORIES
export const saveCategoriesToStorage = (store) => {
  if (!storageAvailable) return
  store.subscribe(
    _.throttle(() => {
      LS.set('categories', store.getState().categories.list)
    }, 1000)
  )
}
export const getCategoriesFromStorage = (store) => {
  if (!storageAvailable) return
  // const products = localStorage.getItem('products');
  const categories = LS.get('categories')
  if (!categories) return
  store.dispatch({
    type: 'UPDATE_CATEGORIES_LIST',
    list: _.keyBy(categories, 'id'),
  })
}

// CART
export const saveCartToStorage = (store) => {
  if (!storageAvailable) return
  let cart = JSON.stringify(store.getState().cart.list)
  store.subscribe(() => {
    let oldCart = cart
    cart = JSON.stringify(store.getState().cart.list)
    if (cart !== oldCart) {
      // localStorage.setItem('products', JSON.stringify(currentValue));
      // console.log('CART udpated');
      LS.set('cart', JSON.parse(cart))
    }
  })
}
export const getCartFromStorage = (store) => {
  if (!storageAvailable) return
  // const products = localStorage.getItem('products');
  const cart = LS.get('cart')
  if (!cart) return
  store.dispatch({
    type: 'SET_CART_LIST',
    list: cart,
  })
}

// CART (Supplier)
export const saveSupplierCartToStorage = (store) => {
  if (!storageAvailable) return
  let cartSupplier = JSON.stringify(store.getState().cartSupplier)
  store.subscribe(() => {
    let oldCartSupplier = cartSupplier
    cartSupplier = JSON.stringify(store.getState().cartSupplier)
    if (cartSupplier !== oldCartSupplier) {
      LS.set('cartSupplier', JSON.parse(cartSupplier))
    }
  })
}
export const getSupplierCartFromStorage = (store) => {
  if (!storageAvailable) return
  const cartSupplier = LS.get('cartSupplier')
  if (!cartSupplier) return
  store.dispatch({
    type: 'UPDATE_CART_SUPPLIER',
    cart: cartSupplier,
  })
}

// CART (3PL)
export const save3plCartToStorage = (store) => {
  if (!storageAvailable) return
  let cart3pl = JSON.stringify(store.getState().cart3pl)
  store.subscribe(() => {
    let oldCart3pl = cart3pl
    cart3pl = JSON.stringify(store.getState().cart3pl)
    if (cart3pl !== oldCart3pl) {
      LS.set('cart3PL', JSON.parse(cart3pl))
    }
  })
}
export const get3plCartFromStorage = (store) => {
  if (!storageAvailable) return
  const cart3PL = LS.get('cart3PL')
  if (!cart3PL) return
  store.dispatch({
    type: 'UPDATE_CART_3PL',
    cart: cart3PL,
  })
}

// ACTIVE CUSTOMER (Supplier)
export const saveSupplierActiveCustomerToStorage = (store, additionalIdentifier) => {
  if (!storageAvailable) return
  let activeCustomer = JSON.stringify(store.getState().supplier.activeCustomer)
  store.subscribe(() => {
    LS.set('activeCustomerSupplier' + additionalIdentifier, JSON.parse(activeCustomer))
  })
}
export const getSupplierActiveCustomerFromStorage = (store, additionalIdentifier) => {
  if (!storageAvailable) return
  const activeCustomer = LS.get('activeCustomerSupplier' + additionalIdentifier)
  if (!activeCustomer) return
  store.dispatch({
    type: 'SET_ACTIVE_CUSTOMER',
    value: activeCustomer,
  })
}

// ACTIVE CUSTOMER (3PL)
export const save3plActiveCustomerToStorage = (store, additionalIdentifier) => {
  if (!storageAvailable) return
  let activeCustomer = JSON.stringify(store.getState().threePL.activeCustomer)
  store.subscribe(() => {
    let oldActiveCustomer = activeCustomer
    activeCustomer = JSON.stringify(store.getState().threePL.activeCustomer)
    if (activeCustomer !== oldActiveCustomer) {
      LS.set('activeCustomer3PL' + additionalIdentifier, JSON.parse(activeCustomer))
    }
  })
}
export const get3plActiveCustomerFromStorage = (store, additionalIdentifier) => {
  if (!storageAvailable) return
  const activeCustomer = LS.get('activeCustomer3PL' + additionalIdentifier)
  if (!activeCustomer) return
  store.dispatch({
    type: 'SET_3PL_ACTIVE_CUSTOMER',
    value: activeCustomer,
  })
}

// Provide ttl in minutes
export const setItemInStorageWithExpiry = (key, additionalIdentifier = '', value, ttl = 0) => {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire

  // Convert minutes in ms
  let timeInMilliSeconds = ttl * 60 * 1000

  const item = {
    value: value,
    expiry: now.getTime() + timeInMilliSeconds,
  }
  localStorage.setItem(key + additionalIdentifier, JSON.stringify(item))
}

export const getItemFromStorageWithExpiry = (key, additionalIdentifier = '') => {
  const itemStr = localStorage.getItem(key + additionalIdentifier)

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key + additionalIdentifier)
    return null
  }
  return item.value
}
